import classNames from 'classnames';
import SectionModules from 'containers/Sections/SectionModules';
import Shell from 'components/Shell/Shell';
import StyleContextProvider from 'utils/context/StyleContextProvider';
import { Contentful, getMasterControl, getBlogs } from '@viome/vnxt-nucleus';
import ErrorPage from 'pages/404';
import BlogArticles from 'components/Blog/BlogArticles';
import {
    contentfulOptions as options,
    EXCLUDED_BLOG_CATEGORIES,
} from 'utils/constants';
import styles from '../blog/blog.module.scss';

const Page = (props) => {
    const { preview, slug, masterControl, page, blogs } = props,
        sections = page?.content?.sections.items;

    if (page.error) {
        return <ErrorPage />;
    }

    return (
        <Shell
            masterControl={masterControl}
            page={page}
            preview={preview}
            className={classNames(`${slug} viome viome3`)}
        >
            <SectionModules modules={sections} />
            <StyleContextProvider styles={styles}>
                <section className={classNames(styles.blog__section)}>
                    <BlogArticles
                        blogArticles={blogs}
                        limit={6}
                        skip={0}
                        preview={preview}
                        infinite
                        slug={blogs.slug}
                        section
                    />
                </section>
            </StyleContextProvider>
        </Shell>
    );
};

export default Page;

export async function getStaticProps() {
    const initialBlogsAmount = 6,
        pageData = Promise.all([
            getMasterControl.get(options),
            Contentful(
                'page',
                {
                    include: 10,
                    'fields.slug[in]': 'vls-publications',
                },
                false,
                options,
            ),
            getBlogs.getBlogsByTopic(
                'research',
                options,
                initialBlogsAmount,
                0,
                EXCLUDED_BLOG_CATEGORIES,
            ),
        ]),
        props = await pageData.then(async ([masterControl, page, blogs]) => ({
            preview: options.isPreview,
            slug: 'publications',
            masterControl,
            page,
            blogs,
        }));

    return { props, revalidate: 600 };
}
